import { Box } from '@factorialco/deprecated-design-system'

import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

import Card from '../../Card'

interface Props {
  activeCustomTimeRangeCategories: CustomTimeRangeCategory[]
}

const ActiveCategoriesSection = ({ activeCustomTimeRangeCategories }: Props) => {
  if (activeCustomTimeRangeCategories.length === 0) {
    return null
  }

  return (
    <Box gap="s8">
      {activeCustomTimeRangeCategories.map((category) => (
        <Card key={category.id} category={category} />
      ))}
    </Box>
  )
}

export default ActiveCategoriesSection
